<template>
  <div>
    <div class="biljeske-top-line">
        <div class="case-tabs">
            <div class="case-tab case-tab-unutarnji active">Unutarnji</div>
            <div class="case-tab case-tab-vanjski">Vanjski</div>
        </div>
        <div class="biljeske-search crm-search"><input type="text" placeholder="Pretraži bilješke.."><div class="top-search-button"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"><g><g><path fill="#fff" d="M25.714 25.714a.952.952 0 0 1-1.346 0l-6.295-6.295A10.95 10.95 0 0 1 11 21.999C4.925 22 0 17.076 0 11 0 4.926 4.925 0 11 0s11 4.926 11 11c0 2.696-.972 5.161-2.581 7.074l6.295 6.295a.952.952 0 0 1 0 1.346zM20 11a9 9 0 1 0-18 0 9 9 0 0 0 18 0z"/></g></g></svg></div></div>
    </div>
    <div class="secondary-tabs">
        <div class="secondary-tab active">Bilješke</div>
        <div class="secondary-tab">FAQ</div>
        <div class="secondary-tab">Tagovi</div>
        <div class="secondary-tab">Templates</div>
    </div>
    <div class="biljeske-main-wrapper">
        <div class="biljeske-info-line">
            <div class="biljeske-info-line-left">
                <div class="biljeske-tags">
                    <div class="biljeske-tag">#generalno</div>
                    <div class="biljeske-tag"><svg xmlns="http://www.w3.org/2000/svg" width="16.219" height="16.219" viewBox="0 0 16.219 16.219"><path id="usklicnik" fill="#ef4463" fill-rule="evenodd" class="cls-1" d="M330.111,371.778a8.111,8.111,0,1,0,8.111,8.111A8.135,8.135,0,0,0,330.111,371.778Zm0,1.623a1.45,1.45,0,0,1,1.46,1.622l-0.649,6.488H329.3l-0.649-6.488A1.45,1.45,0,0,1,330.111,373.4Zm0,12.977a1.622,1.622,0,1,1,1.622-1.622A1.627,1.627,0,0,1,330.111,386.378Z" transform="translate(-322 -371.781)"/></svg> važno</div>
                    <div class="biljeske-tag">#presude</div>
                    <div class="biljeske-tag">#predmeti</div>
                    <div class="biljeske-tag-more"><svg xmlns="http://www.w3.org/2000/svg" width="29" height="16" viewBox="0 0 29 16"><g><g><path fill="#e5e9fc" d="M5.224.307h17.844a5 5 0 0 1 5 5v5.469a5 5 0 0 1-5 5H5.224a5 5 0 0 1-5-5V5.307a5 5 0 0 1 5-5z"/></g><g><path fill="#3326ae" d="M7.163 6.058a2.201 2.201 0 1 1 0 4.402 2.201 2.201 0 0 1 0-4.402z"/></g><g><path fill="#3326ae" d="M14.163 6.058a2.201 2.201 0 1 1 0 4.402 2.201 2.201 0 0 1 0-4.402z"/></g><g><path fill="#3326ae" d="M21.294 6.106a2.177 2.177 0 1 1 0 4.354 2.177 2.177 0 0 1 0-4.354z"/></g></g></svg></div>
                </div>
            </div>
            <div class="biljeske-info-line-right">
                <div class="novi-dokument">Novi dokument <svg xmlns="http://www.w3.org/2000/svg" width="19" height="22" viewBox="0 0 19 22"><g><g><path fill="#7b7b8a" d="M14.184.486l3.96 3.96a.21.21 0 0 1-.148.36h-3.961a.21.21 0 0 1-.211-.21V.635a.21.21 0 0 1 .36-.149zm4.023 6.343v12.895A2.278 2.278 0 0 1 15.93 22H2.276A2.278 2.278 0 0 1 0 19.724V2.7A2.278 2.278 0 0 1 2.276.424H11.8v5.394c0 .559.453 1.011 1.011 1.011zm-5.395 4.383c0-.559-.453-1.011-1.011-1.011h-1.686V8.515a1.011 1.011 0 0 0-2.023 0V10.2H6.406a1.011 1.011 0 1 0 0 2.022h1.686v1.686a1.011 1.011 0 1 0 2.023 0v-1.686h1.686c.558 0 1.011-.452 1.011-1.011z"/></g></g></svg></div>
                <div class="novi-folder">Novi folder <svg xmlns="http://www.w3.org/2000/svg" width="28" height="22" viewBox="0 0 28 22"><g><g><path fill="#7b7b8a" d="M27.721 6.067v13.471A2.46 2.46 0 0 1 25.286 22H2.555A2.46 2.46 0 0 1 .12 19.538V3.291A2.46 2.46 0 0 1 2.555.827h9.02a.338.338 0 0 1 .27.122l2.232 2.657h11.209a2.46 2.46 0 0 1 2.435 2.461zm-8.74 6.633a.979.979 0 0 0-.978-.978h-3.105V8.616a.979.979 0 0 0-1.955 0v3.106H9.838a.979.979 0 0 0 0 1.956h3.105v3.106c0 .539.438.978.977.978.54 0 .978-.44.978-.978v-3.106h3.105c.539 0 .977-.439.977-.978z"/></g></g></svg></div>
            </div>
        </div>
        <div class="biljeske-item-wrapper">
          <div class="biljeska biljeska-level1">
            <div class="biljeska-left">
              <div class="biljeska-no">1</div>
                <div class="biljeska-title">Presude, odluke o predmetima</div>
              </div>
              <div class="biljeska-right">
                  <div class="biljeska-arrow ba-r"><i class="arr-right"></i></div>
              </div>
          </div>
          <div class="biljeska biljeska-level1 biljeska-level-opened">
            <div class="biljeska-left">
              <div class="biljeska-no">2</div>
                <div class="biljeska-title">Generalne bilješke</div>
              </div>
              <div class="biljeska-right">
                  <div class="biljeska-arrow ba-r"><i class="arr-right"></i></div>
              </div>
          </div>
          <div class="biljeska biljeska-level2 biljeska-level-opened">
            <div class="biljeska-left">
              <div class="biljeska-no">2.1</div>
                <div class="biljeska-title">Javno upravno pravo</div>
              </div>
              <div class="biljeska-right">
                  <div class="biljeska-arrow ba-r"><i class="arr-right"></i></div>
              </div>
          </div>
          <div class="biljeska biljeska-level3 biljeska-level-opened">
            <div class="biljeska-left">
              <div class="biljeska-no">2.1.1</div>
                <div class="biljeska-title">Policijski i inspekcijski poslovi</div>
              </div>
              <div class="biljeska-right">
                  <div class="biljeska-arrow ba-r"><i class="arr-right"></i></div>
              </div>
          </div>
          <div class="biljeska biljeska-level4">
            <div class="biljeska-left">
              <div class="biljeska-no">2.1.1.1</div>
                <div class="biljeska-title">Bilješka</div>
              </div>
              <div class="biljeska-right">
                  <div class="biljeska-otvori">otvori</div>
              </div>
          </div>
          <div class="biljeska biljeska-level4">
            <div class="biljeska-left">
              <div class="biljeska-no">2.1.1.2</div>
                <div class="biljeska-title">Bilješka</div>
              </div>
              <div class="biljeska-right">
                  <div class="biljeska-otvori">otvori</div>
              </div>
          </div>
          <div class="biljeska biljeska-level3 biljeska-level-opened">
            <div class="biljeska-left">
              <div class="biljeska-no">2.1.2</div>
                <div class="biljeska-title">Komunalni poslovi</div>
              </div>
              <div class="biljeska-right">
                  <div class="biljeska-arrow ba-r"><i class="arr-right"></i></div>
              </div>
          </div>
          <div class="biljeska biljeska-level4">
            <div class="biljeska-left">
              <div class="biljeska-no">2.1.2.1</div>
                <div class="biljeska-title">Bilješka</div>
              </div>
              <div class="biljeska-right">
                  <div class="biljeska-otvori">otvori</div>
              </div>
          </div>
          <div class="biljeska biljeska-level4">
            <div class="biljeska-left">
              <div class="biljeska-no">2.1.2.2</div>
                <div class="biljeska-title">Bilješka</div>
              </div>
              <div class="biljeska-right">
                  <div class="biljeska-otvori">otvori</div>
              </div>
          </div>
          <div class="biljeska biljeska-level3">
            <div class="biljeska-left">
              <div class="biljeska-no">2.1.3</div>
                <div class="biljeska-title">Vodoprivredni poslovi</div>
              </div>
              <div class="biljeska-right">
                  <div class="biljeska-arrow ba-r"><i class="arr-right"></i></div>
              </div>
          </div>
          <div class="biljeska biljeska-level3">
            <div class="biljeska-left">
              <div class="biljeska-no">2.1.4</div>
                <div class="biljeska-title">Građevinski poslovi</div>
              </div>
              <div class="biljeska-right">
                  <div class="biljeska-arrow ba-r"><i class="arr-right"></i></div>
              </div>
          </div>
        </div>
    </div>
    
  </div>
</template>

<script>
export default {

  data() {

    return {

    };

  },

  methods:{

  },

  mounted(){
    
    this.$store.state.paginacija.title = "Upravljanje znanjem"

  }

}
</script>

<style>
</style>